import React, { useEffect } from 'react';

function PersonalInformationPage({ onBack, onUpdatePasswordClick, onUpdateTransactionPasswordClick, userProfile }) {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  const username = userProfile?.username || 'User';
  const phone = userProfile?.phone || '';

  const handleModifyPersonalInfo = () => {
    // Handle modify personal information action
    console.log('Modify Personal Information');
  };

  const handleUpdatePassword = () => {
    if (onUpdatePasswordClick) {
      onUpdatePasswordClick();
    }
  };

  const handleUpdateTransactionPassword = () => {
    if (onUpdateTransactionPasswordClick) {
      onUpdateTransactionPasswordClick();
    }
  };

  return (
    <div className="personal-info-page">
      {/* Top Navigation Bar */}
      <div className="personal-info-top-bar">
        <div className="personal-info-back-btn" onClick={onBack}>
          <i className="bi bi-chevron-left"></i>
        </div>
        <div className="personal-info-title-text">Modify information</div>
        <div className="personal-info-spacer"></div>
      </div>

      {/* Main Content */}
      <div className="personal-info-content">
        {/* Personal Information Card */}
        <div className="personal-info-card">
          <div 
            className="personal-info-row clickable"
            onClick={handleModifyPersonalInfo}
          >
            <div className="personal-info-row-label">Modify Personal Information</div>
            <div className="personal-info-row-arrow">
              <i className="bi bi-chevron-right"></i>
            </div>
          </div>
          <div className="personal-info-divider"></div>
          <div className="personal-info-row">
            <div className="personal-info-row-label">Username</div>
            <div className="personal-info-row-value">{username}</div>
          </div>
          <div className="personal-info-divider"></div>
          <div className="personal-info-row">
            <div className="personal-info-row-label">Phone</div>
            <div className="personal-info-row-value">{phone}</div>
          </div>
        </div>

        {/* Password Updates Card */}
        <div className="personal-info-card">
          <div 
            className="personal-info-row clickable"
            onClick={handleUpdatePassword}
          >
            <div className="personal-info-row-label">Update Password</div>
            <div className="personal-info-row-arrow">
              <i className="bi bi-chevron-right"></i>
            </div>
          </div>
          <div className="personal-info-divider"></div>
          <div 
            className="personal-info-row clickable"
            onClick={handleUpdateTransactionPassword}
          >
            <div className="personal-info-row-label">Update Transaction Password</div>
            <div className="personal-info-row-arrow">
              <i className="bi bi-chevron-right"></i>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default PersonalInformationPage;

